import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LeadService } from 'src/app/private/services/lead.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';
import { pipelineStageLabel } from 'src/app/utils/crm-lead-pipeline.util';

@Component({
  selector: 'app-bulk-update-lead',
  templateUrl: './bulk-update-lead.component.html',
  styleUrls: ['./bulk-update-lead.component.scss']
})
export class BulkUpdateLeadComponent {

  @Output() close = new EventEmitter<void>();
  @Input() selectedLeads: any[] = [];
  btnLoading = false;
  @Input() users: any[] = [];
  @Output() reload = new EventEmitter<void>();
  @Input() pipelines: any[] = [];

  constructor(
    private toaster: ToastrService,
    private api: LeadService,
    private localstorage: LocalStorageService,
    private tracker: TrackingService
  ) { }


  closeModal() {
    this.close.emit();
  }

  formValues = {
    source: null,
    type: null,
    status: null,
    assignTo: null,
    pipeline_id: null
  };

  ngOnInit() {
    console.log("selectedLeads", this.selectedLeads);
    console.log("users", this.users);
    console.log("pipelines", this.pipelines);
    if(this.pipelines?.length > 0) {
      this.formValues.pipeline_id = this.pipelines[0].pipeline_id;
      this.getLeadStages({ target: { value: this.pipelines[0].pipeline_id } });
    }
  }

  sourceOptions: string[] = [
    'Tina',
    'WhatsApp',
    'Channel Partner',
    'Conference',
    'Field Visit',
    'Google',
    'Instagram',
    'Lead Gen Tools',
    'Live Session',
    'Personal',
    'Referral',
    'LinkedIn',
    'Website',
    'Intern',
    'Other'
  ];
  typeOptions = ['Cold Lead', 'Warm Lead', 'Hot Lead'];

  statusOptions: any[] = [];


  submitUpdateLeads() {
    this.btnLoading = true;
    const payload: any = {
      lead_id: this.selectedLeads.map(lead => lead.lead_id),
      client_id: this.localstorage.getClientId(),
      center_id: this.localstorage.getCenterId(),
      updated_by: {
        prefix: this.localstorage.getPrefix(),
        fname: this.localstorage.getFirstName(),
        lname: this.localstorage.getLastName(),
        email: this.localstorage.getEmail()
      },
      assign_to: {
        prefix: this.users.find(user => user.user_id === this.formValues.assignTo)?.prefix,
        fname: this.users.find(user => user.user_id === this.formValues.assignTo)?.fname,
        lname: this.users.find(user => user.user_id === this.formValues.assignTo)?.lname,
        email: this.users.find(user => user.user_id === this.formValues.assignTo)?.email,
        user_id: this.users.find(user => user.user_id === this.formValues.assignTo)?.user_id
      },
      lead_status: this.formValues.status,
      lead_source: this.formValues.source,
      lead_type: this.formValues.type,
    };

    if (this.formValues.source == null) {
      delete payload.lead_source;
    }

    if (this.formValues.type == null) {
      delete payload.lead_type;
    }

    if (this.formValues.status == null) {
      delete payload.lead_status;
    }

    if (this.formValues.pipeline_id == null) {
      delete payload.pipeline_id;
    }

    if (this.formValues.assignTo == null) {
      delete payload.assign_to;
    }

    this.api.updateBulkLead(payload).subscribe({
      next: (res) => {
        this.toaster.success(res.message);
        this.btnLoading = false;
        this.closeModal();
        this.reload.emit();
         const updatedFields: string[] = [];
      if (payload.lead_status) updatedFields.push(`status: ${payload.lead_status}`);
      if (payload.lead_source) updatedFields.push(`source: ${payload.lead_source}`);
      if (payload.lead_type) updatedFields.push(`type: ${payload.lead_type}`);
      if (payload.assign_to?.email) updatedFields.push(`assigned to: ${payload.assign_to.email}`);
      const desc = `Bulk lead update for ${payload.lead_id.length} lead(s). Updated fields: ${updatedFields.join(', ')}`;
      this.tracker.track('Update', 'Lead', desc);
      },
      error: (err) => {
        this.toaster.error(err.error.message || 'Something went wrong');
        this.btnLoading = false;
      }
    });

  }

  getLeadStages(e: any): void {
    const pipelineId = e?.target?.value || e;
    const pipe = (this.pipelines || []).find(
      (item: any) => String(item.pipeline_id) === String(pipelineId)
    );
    this.statusOptions = (pipe?.stages || []).map((stage: any) => {
      return {
        value: stage.stage_name,
        label: pipelineStageLabel(stage)
      }
    });
  }


}
